import { WindowWithDataLayer } from '@/features/analytics/types'

import { eventBus } from '../bus'

declare const window: WindowWithDataLayer

function pushToDataLayer(event: string, payload: Record<string, unknown>) {
    if (typeof window === 'undefined' || !window.dataLayer) return

    window.dataLayer.push({ event, ...payload })
}

export function registerGtmSubscribers(events: Set<string>) {
    if (events.has('seo_description_show_more_debug')) {
        eventBus.subscribe('seo_description.show_more_clicked', (payload) => {
            pushToDataLayer('seo_description_show_more_debug', { ...payload, version: 'gtm' })
        })
    }
}
